import * as constants from '../../constants';
import * as ListHelpers from './ListHelpers';
export { renderContent } from './ListOfUsers';
export function actionHandlerCallback(actionType, ids = []) {
    const { actionHandlerCallback } = this.props;
    const { content } = this.state;
    let rows = content.rows.filter(row => ids.indexOf(row.columns['Id']) !== -1);
    let emails = rows.map((item) => item.columns.Email);
    if (actionType === constants.actionTypes.export && this.actionHandlerCallbackDefault)
        this.actionHandlerCallbackDefault(actionType, ids);
    else if (actionHandlerCallback) actionHandlerCallback(actionType, ids, emails);
}
export async function loadData(page, pageSize, sortBy = '', isDesk = false, filterValues = []) {
    filterValues = Object.assign([], filterValues);
    filterValues = Object.assign(filterValues, this.props.additionalFilter);
    filterValues.State = [constants.alfrescoUserSates.Active];
    await ListHelpers.loadListData.bind(this)(`Table/Get?searchTableTypes=${constants.searchTableTypes.Users}&withAction=${false}`, page, pageSize, sortBy, isDesk, filterValues);
    const { content } = this.state;
    if (content?.allColumns) {
        const stateCol = content.allColumns.find((item) => item.name === "State");
        if (stateCol)
            stateCol.canFilter = false;
    }
}